module.exports = __webpack_public_path__ + "static/media/SelfCompassionAndAcceptance.ce9ecadc.mp3";